import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { CustomerUser } from '@ansvar-sakerhet/api-client';
import { customerUserKeys } from './customerUsers.key';

export type CustomerUserDetail = CustomerUser & {
  projectCustomerUser?: Array<{ projectId: string }>;
};

export function useGetCustomerUser(customerUserId: string | undefined) {
  const getApi = useApi();

  return useQuery({
    queryKey: [...customerUserKeys.all, 'one', customerUserId],
    queryFn: async () => {
      if (!customerUserId) {
        throw new Error('useGetCustomerUser requires a customerUserId');
      }

      const api = await getApi();
      const res = await api.customerUserFindOneOfMine(customerUserId);
      return res.data as CustomerUserDetail;
    },
    enabled: Boolean(customerUserId),
  });
}
